import { Pipe, PipeTransform } from '@angular/core';



export class MinPipe implements PipeTransform {
  transform(value: number[], args: string[]): any {
    return Math.min.apply(null, value);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'min'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
